import { render, staticRenderFns } from "./ObjectFitIEFixPage.vue?vue&type=template&id=08714851&"
import script from "./ObjectFitIEFixPage.vue?vue&type=script&lang=ts&"
export * from "./ObjectFitIEFixPage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports